import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const NavigationGuardContext = createContext({});
const useNavigationGuard = () => useContext(NavigationGuardContext);

const NavigationGuardProvider = ({ children }) => {
    const [callback, setCallback] = useState(null);

    const guard = useCallback(
        (navigate) => {
            if (!callback) return navigate();
            callback(navigate);
        },
        [callback]
    );

    const onBeforeNavigate = useCallback((func) => {
        setCallback(() => func);
    }, []);

    const value = useMemo(
        () => ({
            guard,
            onBeforeNavigate,
        }),
        [guard, onBeforeNavigate]
    );

    return <NavigationGuardContext.Provider value={value}>{children}</NavigationGuardContext.Provider>;
};

export { useNavigationGuard };
export default NavigationGuardProvider;
